/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import "prismjs/themes/prism-tomorrow.css"
import wrapWithProvider from "./src/wrap-with-provider"

export const wrapRootElement = wrapWithProvider
